export const dataForDayTemplate = (dataArray, statusOptions,labels,title) => {
     
    let dataForDay = {
      labels:labels,
      datasets: [{
          label: title,
          data: dataArray,
          borderWidth: 1,
          backgroundColor: statusOptions ? statusOptions.map((color) => {
            // Define a mapping of color labels to corresponding colors
            const colorMappings = {
              black: 'rgba(0, 0, 0)',   // Example color for 'black'
              purple: 'rgba(128, 0, 128)', // Example color for 'purple'
              red: 'rgba(255, 0, 0)',    // Example color for 'red'
              white: 'rgba(255, 255, 255)', // Example color for 'white'
              yellow: 'rgba(255, 255, 0)', // Example color for 'yellow'
              green: 'rgba(0, 128, 0)',   // Example color for 'green'
              blue: 'rgba(0, 0, 255)',    // Example color for 'blue'
            };
    
            // Use the mapping to set the background color for each data point
            return colorMappings[color];
          }) : [],
        }]
    }
     
    return dataForDay
  }

  export const dataForLucketTemplate = (dataArray, backgroundColors,labels, title) => {
    let dataForDay = {
      labels:labels,
      datasets: [{
          label: title,
          data: dataArray,
          borderWidth: 1,
          backgroundColor:backgroundColors
    }]}
     
    return dataForDay
  }
